import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { ListResponse, StudentState, StudentFilterPayload } from '../types'

export const studentApiSlice = createApi({
    reducerPath: 'studentApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Student'],
    endpoints: (build) => ({
        fetchAllStudents: build.query<ListResponse<StudentState>, { page: number; size: number; filter?: string }>({
            query: (params) => ({
                url: `student`,
                params
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Student' as const,
                            id,
                        })),
                        { type: 'Student', id: 'LIST' },
                    ]
                    : [{ type: 'Student', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<StudentState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),
        fetchFilteredStudents: build.query<ListResponse<StudentState>, { page: number; size: number; type: string; search?: string; filter?: StudentFilterPayload }>({
            query: (params) => ({
                url: `user-course/students-filtered?page=${params.page}&size=${params.size}&filter=${params.search}&type=${params.type}`,
                method: 'POST',
                body: params.filter,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Student' as const,
                            id,
                        })),
                        { type: 'Student', id: 'LIST' },
                    ]
                    : [{ type: 'Student', id: 'LIST' }],
            transformResponse: (response: { data: ListResponse<StudentState> }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),

        createStudent: build.mutation<void, StudentState>({
            query: (student) => ({
                url: 'student',
                method: 'POST',
                body: student,
            }),
            invalidatesTags: [{ type: 'Student', id: 'LIST' }],
        }),

        updateStudent: build.mutation<void, StudentState>({
            query: (student) => ({
                url: `student/${student.id}`,
                method: 'PUT',
                body: student,
            }),
            invalidatesTags: [{ type: 'Student', id: 'LIST' }],
        }),

        deleteStudent: build.mutation<void, number>({
            query: (id) => ({
                url: `/student/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Student', id }],
        }),

        getStudentsInfoByIds: build.mutation<any, Array<number>>({
            query: (ids) => ({
                url: `student/group`,
                method: 'POST',
                body: ids,
            }),
            transformResponse: (response: any) => response.data,
        }),

        registerByEmail: build.mutation<void, StudentState>({
            query: (user) => ({
                url: `/auth/register-by-email`,
                method: 'POST',
                body: user,
            }),
        }),

        registerByPhone: build.mutation<number, StudentState>({
            query: (user) => ({
                url: `/auth/register-by-phone`,
                method: 'POST',
                body: user,
            }),
            transformResponse: (response: any) => response.data,
        }),
    }),
})
